import { useMemo } from 'react'
import './AuthInfoSpinner.scss'
import iconLoading from './ui-lib/images/icon-loading.svg'
import { _T } from '../../i18n'
import type { FC } from 'react'

const AuthInfoSpinner: FC<{ authInfo: any, authInfoError: any }> = ({ authInfo, authInfoError }) => {
  const [loading, authError, entitlementError] = useMemo(() => {
    const loading = !authInfo && !authInfoError
    const authError = !authInfo && authInfoError
    const entitlementError = authInfo && !authInfo.entitlements
    return [loading, Boolean(authError), Boolean(entitlementError)]
  }, [authInfo, authInfoError])

  const rendered = useMemo(() => (
    <>
      {loading &&
        <div className={'info-area'}>
          <img className="loading-spinner" src={iconLoading} alt={'loading'} />
          {_T('Loading')} ...
        </div>
      }
      {authError &&
        <div className={'info-area'}>{_T('Loading Error')}</div>
      }
      {entitlementError &&
        <div className={'info-area'}>{_T('No Entitlements Found')}</div>
      }
    </>
  ), [authError, entitlementError, loading])

  return rendered
}

export default AuthInfoSpinner
